import React from 'react';

import LinkButton from '@sats-group/ui-lib/react/link-button/link-button';
import Text from '@sats-group/ui-lib/react/text/text';

import ContentContainer from '../../components/content-container/content-container';
import Logo from '../../components/logo/logo';
import type { NamedFC } from '../../types/named-fc.types';

import type { Error as Props } from './error.props';

const Error: NamedFC<Props> = ({ link, logo, text }) => {
  return (
    <div className="error">
      <ContentContainer>
        <div className="error__content">
          <div className="error__logo">
            <Logo {...logo} />
          </div>
          <Text elementName="h1" size={Text.sizes.large}>
            {text}
          </Text>
          {link ? <LinkButton data-test-go-back {...link} /> : null}
        </div>
      </ContentContainer>
    </div>
  );
};

Error.displayName = 'Error';

export default Error;
